module.exports = __webpack_public_path__ + "img/personal_details.e29ec282.svg";